import { memo, useEffect } from 'react';
import LoadingAnim from '../../components/LoadingAnim';
import { useParams } from 'react-router';
import Footer from '../../app/Footer';
import PaSurveyHeader from '../../app/PaSurveyHeader';
import ReactMarkdown from 'react-markdown';
import PatientOrgContainer from '../hooks/PatientOrgContainer';
import { useQuery } from '@tanstack/react-query';
import { retrievePatientMessage } from '../../v2/api/patient-adhoc';

function PaPatientMessageRedirect() {

  const params = useParams<{
    referralMessageId?: string;
  }>();

  const referralMessageId = params.referralMessageId || '';

  const { data, isLoading } = useQuery({
    queryKey: ['patient-message-redirect', referralMessageId],
    enabled: Boolean(referralMessageId),
    retry: false,
    queryFn: async () => retrievePatientMessage(referralMessageId),
  });

  const messageContent = (data?.messageContent || {}) as Record<string, string>;
  const messageHyperlink = messageContent?.resourceUrl;
  const messageText = messageContent?.resourceText || '';

  useEffect(() => {
    if (messageHyperlink) {
      window.location.href = messageHyperlink;
    }
  }, [messageHyperlink]);


  if (isLoading || messageHyperlink) {
    return (
      <div className='flex flex-1 w-full'>
        <LoadingAnim className='h-full p-10 w-full' />
      </div>
    );
  }

  return (
    <PatientOrgContainer.Provider>
    <div className='flex-col flex-1 w-full gap-5 px-5 pt-2'>
      <div className='flex-col flex-1 w-full gap-6'>
        <PaSurveyHeader />

        <div className='text-xl flex-col gap-3'>
          <div className='prose'>
            <ReactMarkdown>{messageText}</ReactMarkdown>
          </div>
        </div>

        <div></div>
      </div>
      <Footer />
    </div>
    </PatientOrgContainer.Provider>
  );
}

export default memo(PaPatientMessageRedirect);
